module.exports = __webpack_public_path__ + "static/media/la-logo.f3fe293b.png";